import React from 'react';
import { motion } from 'framer-motion';
import { ServiceCard } from '../ServiceCard';
import { SectionHeading } from './SectionHeading';
import type { Service } from '../../data/services';

/**
 * BLOCK: services_grid
 * ACF layout name: `block_services_grid`
 *
 * Fields:
 *  - eyebrow   (text)
 *  - heading   (text)
 *  - intro     (textarea, optional)
 *  - services  (relationship → Service CPT; empty = show all)
 *  - footer    (group: text, button_label, button_link — optional)
 *
 * Used on: Home ("Three paths. One intention.") and Start Your Journey
 * ("Find the path that meets you where you are.").
 */

interface ServicesGridProps {
  eyebrow?: string;
  heading: string;
  intro?: string;
  services: readonly Service[];
}
export function ServicesGrid({
  eyebrow,
  heading,
  intro,
  services
}: ServicesGridProps) {
  return <div className="mx-auto max-w-7xl" data-id="element-200" data-mp="2nrayp5kly8l4">
      <SectionHeading eyebrow={eyebrow} heading={heading} intro={intro} align="center" className="mx-auto max-w-2xl" data-id="element-201" data-mp="2sj2i8w5cje1r" />

      <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3" data-id="element-202" data-mp="4sxyzomilymp">
        {services.map((service, index) => <motion.div key={service.id} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.45,
        delay: index * 0.07
      }} data-id="element-203" data-mp="ekk6pazn9fkp" data-mpi={index}>
            <ServiceCard service={service} data-id="element-204" data-mp="ol4b2mign075" />
          </motion.div>)}
      </div>
    </div>;
}